import React from 'react'

export const Header = () => {
    return (
        <div style={ { height:'30px', backgroundColor:'var( --primary, #0062a1 ) ', width:'100%'} }>
        </div>
    )
}
